import styled from 'styled-components'

const ToolboxGroupUi = styled.div`
  margin-bottom: 30px;
`

export default ToolboxGroupUi
